<template>
  <div class="transaction">
    <div class="main_box">
      <div class="left_content">
        <CoinMarket></CoinMarket>
      </div>
      <div class="right_content">
        <div class="left_chart">
          <div class="left_chart_top">
            <KLineChart></KLineChart>
          </div>
          <div class="left_chart_bottom">
            <TradingOperation></TradingOperation>
          </div>
        </div>
        <div class="right_realTime">
          <TimeTrading></TimeTrading>
        </div>
      </div>
    </div>
    <div v-if="isSignIn" class="main_bottom">
      <EntrustDetail
        minWidth="1310px"
        :sliceCurrentTotal="10"
        :sliceHistoryTotal="10"
        :reverseCurrentMore="true"
        :reverseHistoryMore="true"
      ></EntrustDetail>
    </div>
  </div>
</template>
<script>
import CoinMarket from './components/section/CoinMarket'
import KLineChart from './components/section/KLineChart'
import TimeTrading from './components/section/TimeTrading'
import TradingOperation from './components/section/TradingOperation'
import EntrustDetail from './components/section/EntrustDetail'
import { mapGetters } from 'vuex'

export default {
  name: 'Transaction',
  components: {
    CoinMarket,
    KLineChart,
    TimeTrading,
    TradingOperation,
    EntrustDetail
  },
  computed: {
    ...mapGetters(['isSignIn'])
  }
}
</script>
<style lang="less" scoped>
.transaction {
  min-height: 100%;
  min-width: 1310px;
  // padding-bottom: 21px;
  background: #000;
  overflow: hidden;
  .main_box {
    margin: 10px 0;
    height: 820px;
    display: flex;
    flex-direction: row;
    .left_content {
      margin-right: 10px;
    }
    .right_content {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      .left_chart {
        flex-grow: 1;
        margin-right: 10px;
        .left_chart_bottom {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
